import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";
import { entityOfType } from "../../../utils/system-entities";
import { SystemEntity } from "@erp/shared-types";

/**
 * Parse Collection Filing Instruction Step
 *
 * AI extraction over a forwarded email's subject + body to find the rep's
 * filing instruction — e.g. "Gently, file this email with collections thread
 * Col-46 — customer claims POD was signed." Extracts the COL-N thread
 * reference number(s) and any accompanying commentary, ignoring the quoted
 * forwarded content below the instruction.
 */
export const parseCollectionFilingInstructionStep = defineStepConfig({
  type: "parse_collection_filing_instruction",
  name: "Parse Collection Filing Instruction",
  description:
    "Extracts collection thread references (COL-N) and an optional comment from an email-in evidence filing instruction",
  category: "AI & Agents",
  libraryModule: "AccountsReceivable",

  inputSchema: z.object({
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL).describe(
      "The forwarded email carrying the filing instruction",
    ),
  }),

  outputSchema: z.object({
    threadRefs: z
      .array(z.number().int().positive())
      .describe(
        "Collection thread reference numbers mentioned in the instruction (the N in COL-N). Empty when no reference was found.",
      ),
    comment: z
      .string()
      .nullable()
      .describe(
        "The rep's commentary accompanying the filing instruction, to be posted as a thread comment. Null when the instruction carried no commentary.",
      ),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "2 minutes",
    retry: {
      maximumAttempts: 3,
      backoffCoefficient: 2,
      initialInterval: "5 seconds",
    },
  },
});
